// SAD-487 (CAP-03): TanStack Query bindings for zou's CaptureReviewService —
// review cycles on a Pursuit with frozen materials, findings and closure.
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { captureReviewClient } from '../../lib/connect/clients';
const REVIEW_KEY = 'capture-reviews';
export function useCaptureReviews(captureProjectId) {
    return useQuery({
        queryKey: [
            REVIEW_KEY,
            captureProjectId,
            'list'
        ],
        queryFn: async ()=>(await captureReviewClient.listCaptureReviews({
                captureProjectId
            })).reviews,
        retry: false
    });
}
/** One review with its frozen materials and findings. */ export function useCaptureReview(captureProjectId, reviewId) {
    return useQuery({
        queryKey: [
            REVIEW_KEY,
            captureProjectId,
            'review',
            reviewId
        ],
        queryFn: async ()=>captureReviewClient.getCaptureReview({
                captureProjectId,
                reviewId
            }),
        retry: false
    });
}
function useRefreshReviews() {
    const queryClient = useQueryClient();
    return (captureProjectId)=>queryClient.invalidateQueries({
            queryKey: [
                REVIEW_KEY,
                captureProjectId
            ]
        });
}
export function useCreateCaptureReview() {
    const refresh = useRefreshReviews();
    return useMutation({
        mutationFn: async (args)=>(await captureReviewClient.createCaptureReview(args)).review,
        onSuccess: (_r, vars)=>refresh(vars.captureProjectId)
    });
}
/** The server snapshots the hypothesis; the client never sends content. */ export function useAddReviewMaterial() {
    const refresh = useRefreshReviews();
    return useMutation({
        mutationFn: async (args)=>(await captureReviewClient.addCaptureReviewMaterial({
                ...args,
                sourceKind: 'hypothesis',
                sourceId: ''
            })).material,
        onSuccess: (_r, vars)=>refresh(vars.captureProjectId)
    });
}
export function useAddReviewFinding() {
    const refresh = useRefreshReviews();
    return useMutation({
        mutationFn: async (args)=>(await captureReviewClient.addCaptureReviewFinding(args)).finding,
        onSuccess: (_r, vars)=>refresh(vars.captureProjectId)
    });
}
export function useCloseCaptureReview() {
    const refresh = useRefreshReviews();
    return useMutation({
        mutationFn: async (args)=>(await captureReviewClient.closeCaptureReview(args)).review,
        onSuccess: (_r, vars)=>refresh(vars.captureProjectId)
    });
}
